import * as braintree from 'braintree-web';

import { getClientToken } from '../api/tokens';

export async function setupClient(accountId: number): Promise<braintree.Client> {
  const { token } = await getClientToken(accountId);

  return braintree.client.create({
    authorization: token,
  });
}
